'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _jPlayerFormatsMap; /* eslint-disable no-underscore-dangle */


var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _Player2 = require('../models/Player');

var _Player3 = _interopRequireDefault(_Player2);

var _mediaFormats = require('../constants/mediaFormats');

var _mediaFormats2 = _interopRequireDefault(_mediaFormats);

var _htmlMediaEvents = require('../constants/htmlMediaEvents');

var _htmlMediaEvents2 = _interopRequireDefault(_htmlMediaEvents);

var _timeToPercentage = require('../utils/timeToPercentage');

var _timeToPercentage2 = _interopRequireDefault(_timeToPercentage);

var _playerName = require('../constants/playerName');

var _playerName2 = _interopRequireDefault(_playerName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jPlayerFormatsMap = (_jPlayerFormatsMap = {}, (0, _defineProperty3.default)(_jPlayerFormatsMap, _mediaFormats2.default.mp3, 'mp3'), (0, _defineProperty3.default)(_jPlayerFormatsMap, _mediaFormats2.default.aac, 'm4a'), (0, _defineProperty3.default)(_jPlayerFormatsMap, _mediaFormats2.default.ogg, 'oga'), (0, _defineProperty3.default)(_jPlayerFormatsMap, _mediaFormats2.default.flash, 'rtmpa'), (0, _defineProperty3.default)(_jPlayerFormatsMap, _mediaFormats2.default.hls, 'm3u8a'), _jPlayerFormatsMap);

function onError(callback, format) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref.type,
        data = _ref.data,
        jPlayer = _ref.jPlayer;

    var error = new Error(_playerName2.default.JPlayer + ' error');
    var isNetworkError = (0, _get2.default)(jPlayer, 'error.type') === _jquery2.default.jPlayer.error.URL;
    // format errors are also considered network errors by players, so we'll use this flag to
    // allow logging of potential formatting compatibility issues
    var isFormatError = !jPlayerFormatsMap[format];
    error.errorData = { type: type, data: data, isNetworkError: isNetworkError, isFormatError: isFormatError };
    return callback(error);
  };
}

var JPlayer = function (_Player) {
  (0, _inherits3.default)(JPlayer, _Player);

  function JPlayer(jPlayerLibrary) {
    var _this$jPlayerEventMap;

    (0, _classCallCheck3.default)(this, JPlayer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (JPlayer.__proto__ || (0, _getPrototypeOf2.default)(JPlayer)).call(this, _playerName2.default.JPlayer));

    _this.jPlayerLibrary = jPlayerLibrary;
    _this.volume = null;
    _this.jPlayerEventMap = (_this$jPlayerEventMap = {}, (0, _defineProperty3.default)(_this$jPlayerEventMap, _htmlMediaEvents2.default.playing, _jquery2.default.jPlayer.event.playing), (0, _defineProperty3.default)(_this$jPlayerEventMap, _htmlMediaEvents2.default.play, _jquery2.default.jPlayer.event.play), (0, _defineProperty3.default)(_this$jPlayerEventMap, _htmlMediaEvents2.default.progress, _jquery2.default.jPlayer.event.progress), (0, _defineProperty3.default)(_this$jPlayerEventMap, _htmlMediaEvents2.default.waiting, _jquery2.default.jPlayer.event.waiting), (0, _defineProperty3.default)(_this$jPlayerEventMap, _htmlMediaEvents2.default.stalled, _jquery2.default.jPlayer.event.stalled), (0, _defineProperty3.default)(_this$jPlayerEventMap, _htmlMediaEvents2.default.timeupdate, _jquery2.default.jPlayer.event.timeupdate), (0, _defineProperty3.default)(_this$jPlayerEventMap, _htmlMediaEvents2.default.ended, _jquery2.default.jPlayer.event.ended), (0, _defineProperty3.default)(_this$jPlayerEventMap, _htmlMediaEvents2.default.error, _jquery2.default.jPlayer.event.error), _this$jPlayerEventMap);
    return _this;
  }

  (0, _createClass3.default)(JPlayer, [{
    key: 'on',
    value: function on(event, callback) {
      var jPlayerEvent = this.jPlayerEventMap[event];
      if (!jPlayerEvent) {
        return;
      }

      var callbackToUse = callback;

      if (jPlayerEvent === _jquery2.default.jPlayer.event.error) {
        callbackToUse = onError(callback, this.format);
        this.cachedErrorCallback = callbackToUse;
      }

      this.jPlayerLibrary.on(jPlayerEvent, callbackToUse);
    }
  }, {
    key: 'off',
    value: function off(event, callback) {
      var jPlayerEvent = this.jPlayerEventMap[event];
      if (!jPlayerEvent) {
        return;
      }

      var callbackToUse = callback;

      if (jPlayerEvent === _jquery2.default.jPlayer.event.error) {
        callbackToUse = this.cachedErrorCallback;
        delete this.cachedErrorCallback;
      }

      this.jPlayerLibrary.off(jPlayerEvent, callbackToUse);
    }

    /**
     * This is necessary on Safari mobile and desktop browsers due to autoplay restrictions.
     * See PlayerLoader.js for more details.
     * @param blankMp3Url {string}
     */

  }, {
    key: 'preload',
    value: function preload(blankMp3Url) {
      this.jPlayerLibrary.jPlayer('setMedia', { mp3: blankMp3Url });
      this.jPlayerLibrary.jPlayer('play');
    }
  }, {
    key: 'load',
    value: function load(url, format) {
      var _this2 = this;

      var mediaFormat = jPlayerFormatsMap[format];
      var media = (0, _defineProperty3.default)({}, mediaFormat, url);
      this.format = format;

      return new _promise2.default(function (resolve, reject) {
        _this2.jPlayerLibrary.one(_jquery2.default.jPlayer.event.canplay, resolve);
        _this2.jPlayerLibrary.one(_jquery2.default.jPlayer.event.error, onError(reject, format));
        _this2.jPlayerLibrary.jPlayer('setMedia', media);
      });
    }
  }, {
    key: 'play',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(playPosition) {
        var _this3 = this;

        var playEvent, duration, percentage;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new _promise2.default(function (resolve, reject) {
                  _this3.jPlayerLibrary.one(_jquery2.default.jPlayer.event.error, onError(reject, _this3.format));
                  _this3.jPlayerLibrary.one(_jquery2.default.jPlayer.event.playing, resolve);
                  _this3.jPlayerLibrary.jPlayer('play');
                });

              case 2:
                playEvent = _context.sent;
                duration = (0, _get2.default)(playEvent, 'jPlayer.status.duration');
                percentage = (0, _timeToPercentage2.default)(playPosition, duration);

                if (percentage) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return');

              case 7:
                this.jPlayerLibrary.jPlayer('playHead', percentage);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function play(_x2) {
        return _ref2.apply(this, arguments);
      }

      return play;
    }()
  }, {
    key: 'seek',
    value: function seek(position) {
      // TUNE-9375 As late as Chrome 78, seeking to 100% causes player to hang for
      // several seconds before tuning to next topic
      this.jPlayerLibrary.jPlayer('playHead', position === 100 ? 99.99 : position);
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.jPlayerLibrary.jPlayer('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.jPlayerLibrary.jPlayer('stop');
    }
  }, {
    key: 'canChangePlaybackRate',
    value: function canChangePlaybackRate() {
      return !!this.jPlayerLibrary.data('jPlayer').status.playbackRateEnabled;
    }
  }, {
    key: 'getPlaybackRate',
    value: function getPlaybackRate() {
      return this.jPlayerLibrary.data('jPlayer').status.playbackRate;
    }

    // http://jplayer.org/latest/developer-guide/#jPlayer-option-playbackRate

  }, {
    key: 'changePlaybackRate',
    value: function changePlaybackRate(rate) {
      this.jPlayerLibrary.jPlayer('playbackRate', rate);
    }
  }, {
    key: 'unload',
    value: function unload() {
      this.jPlayerLibrary.jPlayer('clearMedia');
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.jPlayerLibrary.off();
      this.jPlayerLibrary.jPlayer('clearMedia');
      this.jPlayerLibrary.jPlayer('destroy');
    }
  }, {
    key: 'setVolume',
    value: function setVolume(volume) {
      if ((0, _isNumber2.default)(volume)) {
        this.volume = volume;
        this.jPlayerLibrary.jPlayer('volume', volume / 100);
      }
    }
  }, {
    key: 'getVolume',
    value: function getVolume() {
      return this.volume;
    }
  }, {
    key: 'setTitle',
    value: function setTitle(title) {
      this.jPlayerLibrary.jPlayer('setMedia', { title: title });
    }
  }, {
    key: 'getTimes',
    value: function getTimes() {
      var jPlayer = this.jPlayerLibrary.data('jPlayer');
      return {
        elapsedPercent: +jPlayer.status.currentPercentAbsolute.toFixed(6),
        elapsedSeconds: Math.floor(jPlayer.status.currentTime),
        duration: Math.floor(jPlayer.status.duration)
      };
    }
  }]);
  return JPlayer;
}(_Player3.default);

exports.default = JPlayer;
//# sourceMappingURL=JPlayer.js.map